/*
  pdp-qty-limit.js

  Caps the product page quantity selector and says why.

  The ceiling is rendered by Liquid onto the input as `max` / `data-stock-cap`:
  10, or the variant's stock when that is lower. `stepUp()` already honours a
  max attribute, so the number stops climbing on its own — but silently, which
  reads as a dead button. This adds the explanation, and covers the routes that
  bypass the stepper: typing a number, and pasting one.
*/
(function () {
  'use strict';

  /* Loaded from the layout now, so it runs on the cart drawer too — and the
     drawer is present on every page, including the product page. */
  if (window.__pocoQtyLimit) return;
  window.__pocoQtyLimit = true;

  var NOTE = '[data-poco-qty-note], [data-cdi-qtynote]';
  var HARD_CAP = 10;

  function capOf(input) {
    var v = parseInt(input.getAttribute('data-stock-cap') || input.max, 10);
    return isNaN(v) ? HARD_CAP : v;
  }

  /* Each row owns its own note. Falling back to a document-wide lookup would
     make a drawer line light up the product page's message instead. */
  function noteFor(input) {
    var scope =
      input.closest('.cart-item') ||
      input.closest('.price-per-item__container') ||
      input.closest('product-info');
    return scope ? scope.querySelector(NOTE) : null;
  }

  function message(cap) {
    /* Below the cap the limit is stock; at the cap it is the per-order rule,
       and saying "only 10 available" of a well-stocked product would be wrong. */
    if (cap >= HARD_CAP) {
      return 'You can order up to ' + HARD_CAP + ' of this item per order.';
    }
    return cap === 1
      ? 'Only 1 item is available.'
      : 'Only ' + cap + ' items are available.';
  }

  function show(input) {
    var note = noteFor(input);
    if (!note) return;
    note.textContent = message(capOf(input));
    note.hidden = false;
  }

  function hide(input) {
    var note = noteFor(input);
    if (note) note.hidden = true;
  }

  function clamp(input, announce) {
    var cap = capOf(input);
    var value = parseInt(input.value, 10);

    if (isNaN(value) || value < 1) {
      input.value = 1;
      return;
    }

    if (value > cap) {
      input.value = cap;
      if (announce !== false) show(input);
    } else if (value < cap) {
      hide(input);
    }
  }

  function inputs() {
    return document.querySelectorAll('quantity-input .quantity__input[data-stock-cap]');
  }

  function sync(input) {
    var cap = capOf(input);
    var plus = input.parentElement && input.parentElement.querySelector('[name="plus"]');
    if (plus) {
      var atCap = (parseInt(input.value, 10) || 0) >= cap;
      plus.classList.toggle('disabled', atCap);
      plus.setAttribute('aria-disabled', atCap ? 'true' : 'false');
    }
  }

  /* Capture phase: the stepper's own handler runs on the button, and the note
     has to react to a click that is refused as well as one that counts. */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('quantity-input [name="plus"], quantity-input [name="minus"]');
      if (!btn) return;

      var host = btn.closest('quantity-input');
      var input = host && host.querySelector('.quantity__input[data-stock-cap]');
      if (!input) return;

      var before = parseInt(input.value, 10) || 0;

      setTimeout(function () {
        clamp(input, false);
        sync(input);

        var after = parseInt(input.value, 10) || 0;
        if (btn.name === 'plus' && after === before) {
          show(input);      // refused: already at the ceiling
        } else if (btn.name === 'minus') {
          hide(input);
        }
      }, 0);
    },
    true
  );

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('.quantity__input[data-stock-cap]')) return;
    clamp(e.target);
    sync(e.target);
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('.quantity__input[data-stock-cap]')) return;
    clamp(e.target);
    sync(e.target);
  });

  /* The note is rendered next to the quantity box because that is where the
     Liquid for it lives, but it belongs under the whole row — quantity and Add
     to cart — so it is moved once the row is in the DOM. */
  function placeNote(input) {
    /* Drawer rows are laid out already; only the product page needs the note
       relocated under the buy row. */
    if (input.closest('.cart-item')) return;

    var note = noteFor(input);
    if (!note || note.dataset.placed === '1') return;

    var scope = input.closest('product-info') || input.closest('.product__info-container') || document;
    var row = scope.querySelector('.poco-cta-row') || scope.querySelector('.product-form__buttons');
    if (!row || !row.parentNode) return;

    row.parentNode.insertBefore(note, row.nextSibling);
    note.dataset.placed = '1';
  }

  function init() {
    inputs().forEach(function (input) {
      placeNote(input);
      clamp(input, false);
      sync(input);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* A variant switch re-renders the buy buttons with a new cap. */
  document.addEventListener('variant:change', function () { setTimeout(init, 200); });
  document.addEventListener('shopify:section:load', init);
})();
